import { getItem, setItem, removeItem } from "owa-local-storage";
import { getIndexerValueForMailboxInfo, type MailboxInfo } from "owa-client-types";

const COMPLETION_KEY_PREFIX = "owa-personal-os-steady-cached";

function getCompletionKey(accountKey: string): `owa-personal-os-steady-cached_${string}` {
    return `${COMPLETION_KEY_PREFIX}_${accountKey}`;
}

export function hasOnboardingCompletionHintForAccount(accountKey: string): boolean {
    return Boolean(accountKey) && getItem(self, getCompletionKey(accountKey)) === "steady";
}

export function hasOnboardingCompletionHint(mailboxInfo: MailboxInfo): boolean {
    return hasOnboardingCompletionHintForAccount(getIndexerValueForMailboxInfo(mailboxInfo));
}

export function persistOnboardingCompletionHint(accountKey: string): void {
    if (accountKey) {
        setItem(self, getCompletionKey(accountKey), "steady");
    }
}

export function clearOnboardingCompletionHint(accountKey: string): void {
    if (accountKey) {
        removeItem(self, getCompletionKey(accountKey));
    }
}
